import React from "react";
import { OneToMany, OneToOne, ManyToMany } from "./CardinalityShapes";
import { useTranslation } from "react-i18next";

/* refactored - ali */
const CardinalityOptionsField = (props) => {
	const { firstEntityName, secondEntityName, selected, onSelect, showCardinalityLabel } = props;

	const { t } = useTranslation("linked_entity/common");

	return (
		<div className="row my-3">
			{showCardinalityLabel && (
				<div className="col-12">
					<b>{t("cardinality_popup.cardinality_label", { ns: "linked_entity/common" })}</b>
				</div>
			)}
			<div className="col-4">
				<div data-testid="one-one" className={`px-2 py-4 m-1 ms-0 rounded bg-2 ${selected === "1-1" ? "bg-white border-primary" : "op-75  border"}`} onClick={() => onSelect("1-1")}>
					<OneToOne left={firstEntityName} right={secondEntityName}></OneToOne>
				</div>
			</div>
			<div className="col-4">
				<div data-testid="one-many" className={`px-2 py-4 m-1 rounded bg-2 ${selected === "1-*" ? "bg-white  border-primary" : "op-75  border"}`} onClick={() => onSelect("1-*")}>
					<OneToMany left={firstEntityName} right={secondEntityName}></OneToMany>
				</div>
			</div>
			<div className="col-4">
				<div data-testid="many-many" className={`px-2 py-4 m-1 me-0 rounded bg-2 ${selected === "*-*" ? "bg-white border-primary" : " op-75 border"}`} onClick={() => onSelect("*-*")}>
					<ManyToMany left={firstEntityName} right={secondEntityName}></ManyToMany>
				</div>
			</div>
		</div>
	);
};

export default CardinalityOptionsField;
